module.exports = __webpack_public_path__ + "static/media/power.08dd6d2b.svg";